import { render } from "./WykresyDarek.vue?vue&type=template&id=50535eda&ts=true"
import script from "./WykresyDarek.vue?vue&type=script&lang=ts"
export * from "./WykresyDarek.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__